import React from 'react';
import PropTypes from 'prop-types';

import { PRODUCTION_HOSTS } from '@wix/wix-vod-constants/env';
import { getResizedImageUrl } from '@wix/wix-vod-shared/common';

const BackgroundImage = ({
  className,
  dataHook,
  posterUrl,
  width,
  height,
  children,
}) => {
  const imageHost = PRODUCTION_HOSTS.image;
  const resizedPosterUrl = getResizedImageUrl({
    url: posterUrl,
    width,
    height,
    imageHost,
  });

  return (
    <div
      className={className}
      tabIndex="0"
      data-hook={dataHook}
      style={{ backgroundImage: `url(${resizedPosterUrl})` }}
    >
      {children}
    </div>
  );
};

BackgroundImage.propTypes = {
  className: PropTypes.string,
  dataHook: PropTypes.string,
  posterUrl: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  children: PropTypes.node,
};

export default BackgroundImage;
